"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.amplitudeWatchers = exports.watchRequestAmplitudeInitializeSaga = exports.watchRequestAmplitudeEventSaga = void 0;
exports.requestAmplitudeEventSaga = requestAmplitudeEventSaga;
exports.requestAmplitudeInitializeSaga = requestAmplitudeInitializeSaga;
const effects_1 = require("redux-saga/effects");
const actions_1 = require("./actions.js");
const xuder_1 = require("@sonar-software/xuder");
const lib_1 = require("../lib.js");
/* eslint-disable */
function* requestAmplitudeEventSaga(action) {
    /* eslint-enable */
    const { event } = action;
    yield (0, effects_1.call)(lib_1.logAmplitudeEvent, event);
}
exports.watchRequestAmplitudeEventSaga = (0, xuder_1.createWatcherSaga)([
    {
        action: actions_1.AmplitudeActionType.RequestEvent,
        actionHandler: requestAmplitudeEventSaga,
        type: xuder_1.SagaYieldType.Every
    }
]);
/* eslint-disable */
function* requestAmplitudeInitializeSaga(action) {
    /* eslint-enable */
    const { data } = action;
    yield (0, effects_1.call)(lib_1.initializeAmplitude, data);
}
exports.watchRequestAmplitudeInitializeSaga = (0, xuder_1.createWatcherSaga)([
    {
        action: actions_1.AmplitudeActionType.RequestInitialize,
        actionHandler: requestAmplitudeInitializeSaga,
        type: xuder_1.SagaYieldType.Every
    }
]);
exports.amplitudeWatchers = (0, xuder_1.combineAllWatchers)([
    exports.watchRequestAmplitudeEventSaga,
    exports.watchRequestAmplitudeInitializeSaga
]);
//# sourceMappingURL=sagas.js.map